lmApp
/**
 * ------------| Configuration phase |------------
 */
  .config(['$provide', '$httpProvider', '$compileProvider',
    function ($provide, $httpProvider, $compileProvider) {
      $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|itms-services):/);

      //Redirect to login if LH answer with 401 and 403
      var isRequestExcluded = function(response) {
        if (response.config.url === '/discovery:80/sdp/v2/operators/me'
            && response.config.headers.hasOwnProperty('X-Instance-Check')) {
          return true;
        }
        return false;
      };
      $httpProvider.interceptors.push(['$q', '$location', '$rootScope',
        function ($q, $location, $rootScope) {
          return {
            'responseError': function (response) {
              if ((response.status === 401 || response.status === 403) && !isRequestExcluded(response)) {
                $rootScope.logOut();
                $location.path('/');
              }
              return $q.reject(response);
            }
          };
        }]);

      $provide.decorator('$q', ['$delegate', function ($delegate) {
        function seqAll(promises) {

          var deferred = $delegate.defer();

          if (!_.size(promises)) {
            deferred.resolve({});

            return deferred.promise;
          }

          var results = [];
          var j = 0;
          var keys = _.keys(promises);
          recursive(promises[keys[j]]);

          function recursive(promise) {
            j++;

            promise().then(function (data) {

              results[keys[j - 1]] = data;

              if (j < _.size(promises)) {
                recursive(promises[keys[j]]);
              } else {
                deferred.resolve(results);
              }
            }, function (error) {

              deferred.reject({
                key: keys[j - 1],
                error: error
              });

              return;
            });
          }

          return deferred.promise;
        }

        $delegate.seqAll = seqAll;
        return $delegate;
      }]);
    }])

  /**
   * ------------| Used to kickstart the application |------------
   */
  .run(['$rootScope', '$location', '$kookies', '$templateCache', '$compile', '$timeout', '$http', 'AssetService', 'AuthenticationService', 'ModalWindowService', 'ToastService', 'ApiService', 'SuperuserSrv', 'AdministrationService',
    function ($rootScope, $location, $kookies, $templateCache, $compile, $timeout, $http, AssetService, AuthenticationService, ModalWindowService, ToastService, ApiService, SuperuserSrv, AdministrationService) {

      $rootScope.EVENTS = {};
      $rootScope.globals = {};
      $rootScope.isMenuOpen = JSON.parse(localStorage['is-menu-open'] || 'true');
      $rootScope.isMenuManual = !$rootScope.isMenuOpen;

      $rootScope.currentOperator = {
        id: -1,
        title: ''
      };

      $rootScope.getHLSPlayerURL = function (src) {
        return 'https://demo24.noisypeak.com/hls-js/demo/?src=' + src
      }

      $rootScope.getUtilsConfig = function (operator) {

        $rootScope.logo = {
          small: '/images/sotal_cloud_logo_small.png',
          big: '/images/sotal_cloud_logo_big.png',
          menu: '/images/sotal_cloud_logo_header.png'
        };

        if (_.get(window, 'config[' + operator + '].logo')) {
          if (_.get(window, 'config[' + operator + '].logo.menu')) $rootScope.logo.menu = _.get(window, 'config[' + operator + '].logo.menu', '');
          if (_.get(window, 'config[' + operator + '].logo.small')) $rootScope.logo.small = _.get(window, 'config[' + operator + '].logo.small', '');
          if (_.get(window, 'config[' + operator + '].logo.big')) $rootScope.logo.big = _.get(window, 'config[' + operator + '].logo.big', '');
        }

        var params = {};
        if (_.get(window, 'config[' + operator + '].aws')) {
          params = _.get(window, 'config[' + operator + '].aws');
        } else {
          params = {
            region: 'eu-west-1',
            s3_signature_version: ':v4',
            params: {
              Bucket: "sotalcloud-storage-eu"
            },
            accessKeyId: "AKIAWE5QIRPBRVNFKAPW",
            secretAccessKey: "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"
          };
        }

        $rootScope.aws = new AWS.S3(params);
      };

      $rootScope.$on('self:update', function (event, self) {
        $rootScope.logo = {
          small: '/images/sotal_cloud_logo_small.png',
          big: '/images/sotal_cloud_logo_big.png',
          menu: '/images/sotal_cloud_logo_header.png'
        };

        if (!self) return;

        $rootScope.getUtilsConfig(self.name);

        $rootScope.permissions.sections = AdministrationService.GetParseAccountPermissions();
      });

      var infrastructure;
      if (window.config && _.isBoolean(window.config.infrastructure)) {
        infrastructure = window.config.infrastructure;
      } else {
        infrastructure = true;
      }

      $rootScope.infrastructure = infrastructure;



      if (window.config && window.config.stripe) {
        $rootScope.stripe = window.config.stripe;
      } else {
        $rootScope.stripe = {
          // clientId: 'ca_6RAOcF0baHO5tdKOCeLvea6FS2jqNLHd', // SotalCloud (Dev)
          clientId: 'ca_6qA0rusByFmq19FVQP3IyI6cYSuNDUcB',    // SotalCloud (Prod)
          isLive: true
        }
      }

      $rootScope._getServiceIcon = function (service) {
        var iconName;

        switch (true) {
          case service.name.indexOf('smarttv') !== -1:
            iconName = 'monitor-multiple';
            break;

          case service.name.indexOf('and') !== -1:
            iconName = 'android';
            break;

          case service.name.indexOf('ios') !== -1:
            iconName = 'apple';
            break;

          case service.name.indexOf('stb') !== -1:
            iconName = 'nest-protect';
            break;

          case service.name.indexOf('web') !== -1:
            iconName = 'web';
            break;

          default :
            iconName = '';
            break;
        }

        return iconName;
      };

      $rootScope._getServiceName = function (service) {
        var name;

        switch (true) {
          case service.name.indexOf('smarttv') !== -1:
            name = 'Smart TV';
            break;

          case service.name.indexOf('and') !== -1:
            name = 'Android';
            break;

          case service.name.indexOf('ios') !== -1:
            name = 'iOS';
            break;

          case service.name.indexOf('stb') !== -1:
            name = 'STB';
            break;

          case service.name.indexOf('web') !== -1:
            name = 'Web';
            break;

          default :
            name = 'Unknown';
            break;
        }

        return name;
      };

      /**
       * Change window location [<a>]
       * @param path
       */
      $rootScope.go = function (path) {
        var globals = $kookies.get('globals');

        if (_.isString(globals)) {
          globals = JSON.parse(globals);
        }

        //if (!_.isEmpty($rootScope.globals) && $rootScope.globals.currentUser.isSuperuser && !$rootScope.globals.currentUser.operatorToken && path === '/profile') {
        //  return;
        //}

        $rootScope.currentPath = path;

        if (path === '/' && globals) {
          $location.path($rootScope.defaultRoute);
        } else {
          //$location.path(path);
          $location.url(path);
        }
        $rootScope.$broadcast('location:change', path);
      };

      $rootScope.isSuperuser = function () {
        return $rootScope.globals.currentUser && $rootScope.globals.currentUser.isSuperuser;
      };

      /**
       * Logout from current user
       */
      $rootScope.logOut = function () {
        $rootScope.globals = {};
        $rootScope.currentRoute = '';
        $kookies.remove('globals');

        localStorage.clear && localStorage.clear();

        lh.common.config.set({authToken: null});
        $location.path("/");
      };

      //Default route after auth
      $rootScope.defaultRoute = '/profile';
      $rootScope.defaultAdminRoute = '/superuser/operators';

      // keep user logged in after page refresh
      $rootScope.globals = $kookies.get('globals') || {};


      if (_.isString($rootScope.globals)) {
        $rootScope.globals = JSON.parse($rootScope.globals);
      }

      $rootScope.globals.location = window.location.origin

      if ($rootScope.globals.currentUser && !$rootScope.globals.currentUser.account) $rootScope.logOut();

      if ($rootScope.globals.currentUser) {

        if ($rootScope.globals.currentUser.isSuperuser && $rootScope.globals.currentUser.operatorToken) {
          $rootScope.currentOperator.id = $rootScope.globals.currentUser.operatorId;
          $rootScope.currentOperator.title = $rootScope.globals.currentUser.operatorName;

          $rootScope.currentOperator.accounts = localStorage['accounts'] || $rootScope.globals.currentUser.accounts || [];

          if ($rootScope.currentOperator.accounts && _.isString($rootScope.currentOperator.accounts)) {
            $rootScope.currentOperator.accounts = JSON.parse($rootScope.currentOperator.accounts);
          }

          $rootScope.currentOperator.company_name = $rootScope.globals.currentUser.company_name;
          $rootScope.currentOperator.projectName = $rootScope.globals.currentUser.projectName;

          $rootScope.getUtilsConfig($rootScope.currentOperator.title);

          lh.common.config.set({authToken: $rootScope.globals.currentUser.operatorToken});
          lh.system.init();
        } else {
          $rootScope.currentOperator = {};

          $rootScope.getUtilsConfig($rootScope.globals.currentUser.name);

          lh.common.config.set({authToken: $rootScope.globals.currentUser.token});
          lh.system.init();
        }

        ApiService.SetToken($rootScope.globals.currentUser.supervisorToken);

        if ($rootScope.isSuperuser()) {
          SuperuserSrv.GetOperators()
            .then(function (response) {
              var currentOperator = _.find(_.get(response, 'data.data', []), {id: $rootScope.currentOperator.id});
              if (currentOperator) {
                if (currentOperator) {
                  $rootScope._self = currentOperator;

                  $timeout(function () {
                    $rootScope.$broadcast('self:update', currentOperator)
                  }, 350);
                }
              }
            });
        } else {
          ApiService.Request('1/self', 'GET')
            .then(function (response) {
              $rootScope._self = response.self;

              $timeout(function () {
                $rootScope.$broadcast('self:update', response.self)
              }, 350);
            })
            .catch(function (reason) {
              $rootScope._self = {};
              $rootScope.debugInfo(reason, 'silent');
            });
        }

        AssetService.GetPlatforms()
          .then(function (data) {
            $rootScope.platforms = data;
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason);
          });
      }

      $rootScope.permissions = {
        allow: false
      };

      if ($rootScope.globals.currentUser) {
        $rootScope.permissions.sections = AdministrationService.ParseAccountPermissions();
      }

      var clearRoute = function (nextR, currentR) {
        if (currentR === 'vod' && nextR !== 'vod') {
          $location.search('page', null);
          $location.search('vod_id', null);
          $location.search('keyword', null);
        }

        if (currentR === 'live' && nextR !== 'live') {
          $location.search('page', null);
          $location.search('live_id', null);
          $location.search('keyword', null);
        }

        if (currentR === 'offers' && nextR !== 'offers') {
          $location.search('offer_id', null);
        }

        if (currentR === 'plans' && nextR !== 'plans') {
          $location.search('plan_id', null);
        }

        if (currentR === 'packages' && nextR !== 'packages') {
          $location.search('package_id', null);
        }

        if (currentR === 'groups' && nextR !== 'groups') {
          $location.search('group_id', null);
        }

        if (currentR === 'channels' && nextR !== 'channels') {
          $location.search('channel_id', null);
          $location.search('date', null);
        }

        if (currentR === 'catchup-2-0' && nextR !== 'catchup-2-0') {
          $location.search('channel_id', null);
          $location.search('date', null);
          $location.search('program_id', null);
        }

        if (currentR === 'metadata' && nextR !== 'metadata') {
          $location.search('meta', null);
        }
      };

      /**
       * Redirect to login if no auth data
       */
      $rootScope.$on('$locationChangeStart', function (event, next, current) {
        ToastService.HideBig();
        ToastService.HideSmall();

        var path = $location.path().split('/');

        var permission = '';
        if (path[1] && $rootScope.permissions.sections) {
          permission = $rootScope.permissions.sections[path[1]];

          if (permission) {
            if (permission.sections) {
              permission = path[2] && permission.sections[path[2]] ? permission.sections[path[2]].mode : permission.mode;
            } else {
              permission = permission.mode;
            }
          } else {
            permission = '';
          }
        }

        $rootScope.permissions.allow = $rootScope.isDashboardPage() || $rootScope.isLoginPage() || $rootScope.isRegisterPage() || path[1] === 'profile' || permission === 'rw';

        if ((!permission || permission === 'none') && $rootScope.globals.currentUser) {
          //if ($rootScope.globals.currentUser.isSuperuser) {
          //  $location.path($rootScope.defaultAdminRoute);
          //} else {
          $location.path($rootScope.defaultRoute);
          //}

          return;
        }

        var nextR = next.split('/').pop().split('?')[0];
        var currentR = current.split('/').pop().split('?')[0];

        clearRoute(nextR, currentR);

        // redirect to login page if not logged in
        if (!$rootScope.isLoginPage() && !$rootScope.isRegisterPage() && !$rootScope.isDashboardPage() && !$rootScope.globals.currentUser) {
          $location.path('/');
          AuthenticationService.ClearCredentials();
          return;
        }

        if (next.split('/').pop() === '' && $rootScope.globals.currentUser) {
          if ($rootScope.globals.currentUser.isSuperuser) {
            $location.path($rootScope.defaultAdminRoute);
          } else {
            $location.path($rootScope.defaultRoute);
          }
        }
      });

      /**
       * Check if current location is ROOT
       * @returns {boolean}
       */
      $rootScope.isLoginPage = function () {
        return $location.path() == '/' || !$location.path();
      };

      /**
       * Check if current location is registration
       * @returns {boolean}
       */
      $rootScope.isRegisterPage = function () {
        return $location.path().indexOf('/register') === 0 || $location.path().indexOf('/greetings') === 0;
      };

      /**
       * Check if current location is registration
       * @returns {boolean}
       */
      $rootScope.isDashboardPage = function () {
        return $location.path().indexOf('/dashboard') === 0;
      };

      /**
       * Debug functionality
       * TODO: Create logger to server
       * @param data
       */
      $rootScope.debugInfo = function (reason, exeption) {
        $rootScope.namespace = !_.isEmpty($rootScope.globals) ? $rootScope.globals.currentUser.project : 'Root';

        if (exeption || reason.stack) {
          try {
            var message = {
              format: moment.utc().format("MMMM Do YYYY, HH:mm:ss a"),
              timestamp: moment.utc().unix(),
              stack: reason.stack || (reason.error && reason.error.stack) || 'No Stack: ' + reason,
              message: reason.message || 'No Message',
              exeption: exeption ? exeption : 'No Exception',
              data: JSON.stringify(reason.data) || 'No data',
              type: 'exceptionJS'
            };

            ga('send', 'event', 'Error:JS Exception:' + $rootScope.namespace, JSON.stringify(message));

            console.log(message);
          } catch (e) {

            ga('send', 'event', 'Error:CantSend:' + $rootScope.namespace, JSON.stringify(e));

            console.log(e, JSON.stringify(e));
          }

          if (reason.message === 'timeout of 20000ms exceeded') {
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          }

          console.log(reason, JSON.stringify(reason));
          return;
        } else {
          try {
            var message = {
              format: moment.utc().format("MMMM Do YYYY, HH:mm:ss a"),
              timestamp: moment.utc().unix(),
              url: reason.url || 'No Url',
              message: reason.message ? reason.message : 'No message',
              data: JSON.stringify(reason.data) || 'No data',
              type: 'rejectLM'
            };

            ga('send', 'event', 'Error:LM:' + $rootScope.namespace, JSON.stringify(message));

            console.log(message);
          } catch (e) {

            ga('send', 'event', 'Error:CantSend:' + $rootScope.namespace, JSON.stringify(e));

            console.log(e, JSON.stringify(e));
          }
        }

        var openDebugger = function (reason, userIP) {
          var reasonMessage = reason.message

          if (reason.data && reason.data.error && reason.data.error.message) {
            reasonMessage = reason.data.error.message
          }

          var debuggerInner = '<div class="fs-headline">:( Something went wrong ...</div>' +
              '<div class="fs-subhead">Contact us to provide full description of what happened </div>' +
              userIP +
              '<div class="fs-subhead heavy">' + reasonMessage + '</div>';

          debuggerInner = $compile(debuggerInner)($rootScope);

          ModalWindowService.Open({
            content: debuggerInner,
            actions: [
              {
                title: 'OK',
                color: 'light-blue',
                fn: function () {
                  try {
                    var message = {
                      format: moment.utc().format("MMMM Do YYYY, HH:mm:ss a"),
                      timestamp: moment.utc().unix(),
                      url: reason.url,
                      message: reasonMessage,
                      data: JSON.stringify(reason.data),
                      type: 'send'
                    };

                    ga('send', 'event', 'Error:Send:' + $rootScope.namespace, JSON.stringify(message));

                    console.log(message);
                  } catch (e) {
                    ga('send', 'event', 'Error:CantSend:' + $rootScope.namespace, JSON.stringify(e));

                    console.log(e, JSON.stringify(e));
                  }
                }
              }
            ],
            size: {
              s: 4
            }
          });
        }
        
        $http.get('https://www.cloudflare.com/cdn-cgi/trace')
            .then(function(response) {
              var userIP = ''
              if (response.data) {
                var parts = response.data.split('\n')
                for (var i = 0; i < parts.length; i++) {
                  if (parts[i].startsWith('ip')) {
                    userIP = parts[i].substr(3)
                    break
                  }
                }
              }
              if (userIP) {
                userIP = '<div class="fs-subhead">IP: ' + userIP + '</div>'
              }
              openDebugger(reason, userIP)
            })
            .catch(function(error) {
              openDebugger(reason, '')
            });
      };

      $rootScope.toggleMenu = function (event) {
        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        $rootScope.isMenuOpen = !$rootScope.isMenuOpen;
        $rootScope.isMenuManual = true;
        localStorage['is-menu-open'] = JSON.stringify($rootScope.isMenuOpen);
      };

      /**
       * Start progress bar activity
       * @param id
       */
      $rootScope.showLinearProgress = function (id) {
        angular.element(id).show();
      };

      /**
       * Hide all progressbars
       */
      $rootScope.hideLinearProgress = function (id) {
        angular.element(id).hide();
      };

      $rootScope.locale = 'eng';

      window.addEventListener('error', function (e) {
        $rootScope.debugInfo(e, true);
      });

      $timeout(function () {
        $rootScope.$broadcast('location:change', $location.path())
      }, 350);
    }]);
